// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"QeD2Owdha_bIe5Xi8SE6u"};